import React, { useState, useEffect } from 'react';
import './Navbar.scss';
import { Link } from "react-router-dom";


const NAV_LINKS = [
  { label: 'Accueil', href: '/' },
  { label: 'Comment ça marche', href: '/comment-ca-marche' },
  { label: 'Pour les associations', href: '/members/inscription' },
  { label: 'Pour les formateurs', href: '/formateurs' },
  { label: 'Espace femme', href: '/espace-femme' },
  { label: 'Contact', href: '/contact' },
];

const UNFMNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="unfm-navbar">

      <header className="navbar">
        <div className="navbar__container">
          {/* Logo */}
          <a href="/" className="navbar__logo" onClick={closeMenu}>
            <span className="navbar__logo-main">UNFM</span>
            <span className="navbar__logo-sub">2.0</span>
          </a>

          {/* Navigation */}
          <nav
            id="primary-navigation"
            className={`navbar__nav ${isMenuOpen ? 'navbar__nav--open' : ''
              }`}
          >
            <ul className="navbar__links">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="navbar__link"
                    onClick={closeMenu}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="navbar__actions">
              <Link
                to="/members/inscription" 
                className="btn btn--outline"
                onClick={closeMenu}
              >
                Espace professionnel
              </Link>

              <a
                href="/orientation"
                className="btn btn--solid"
                onClick={closeMenu}
              >
                Je m'oriente vers une formation
              </a>
            </div>
          </nav>

          {/* Mobile Toggle */}
          <button
            type="button"
            className={`navbar__toggle ${isMenuOpen ? 'navbar__toggle--open' : ''
              }`}
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
            aria-controls="primary-navigation"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {isMenuOpen && (
          <div
            className="navbar__overlay"
            onClick={closeMenu}
          />
        )}
      </header>
    </div>

  );
};

export default UNFMNavbar;